<template>
	<div class="edit-page-wrapper">
		<PreloaderComponent v-if="preloaderStatus"/>
		<form autocomplete="off" @submit.prevent="handleFormSubmit" v-else>
			<div class="container">
				<div class="row">
					<div class="col-6">
						<h2>Change Password</h2>
						<label for="password">
							<input
								minlength="6"
								id="password"
								type="password"
								placeholder="New Password"
								v-model="password">
						</label>
						<label for="confirm-password">
							<input
								minlength="6"
								id="confirm-password"
								type="password"
								placeholder="Confirm New Password"
								v-model="passwordConfirm">
						</label>
					</div>
					<div class="col-6">
						<h2>Change Email</h2>
						<label>
							<input
								type="email"
								placeholder="Email"
								v-model="email">
						</label>
					</div>
				</div>
				<div class="row" v-if="errorMessage.length">
					<div class="col-6">
						<div class="errors-wrapper">
							<div v-for="(singleError, index) in errorMessage" :key="index">
								{{ singleError }}
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6">

					</div>
					<div class="col-6 buttons-wrapper align-end">
						<input
							type="submit"
							value="Save"
							:disabled="activeStatus"
						>
						<button @click.prevent="handleCancelButton">Cancel</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import SolFileAPIInstance from '@/api'
import PreloaderComponent from '@/components/common/PreloaderComponent'

export default {
	name: "EditAdmin",
	data() {
		return {
			preloaderStatus: true,
			password: '',
			passwordConfirm: '',
			email: '',
			errorMessage: [],
			activeStatus: false
		}
	},
	components: {
		PreloaderComponent
	},

	async mounted() {
		this.preloaderStatus = true;
		const response = await SolFileAPIInstance.getAdminInfo()
		const {
			data: {
				email
			}
		} = response
		this.email = email
		this.preloaderStatus = false;
	},

	methods: {

		handleCancelButton() {
			this.$router.push({
				path: '/'
			})
		},

		validate() {
			this.errorMessage = []
			const {
				password,
				passwordConfirm,
				email
			} = this
			if (password && !passwordConfirm) {
				this.errorMessage.push('Please enter all fields')
			}
			if (passwordConfirm !== password) {
				this.errorMessage.push('Password and confirm password fields should be the same')
			}
			if (!email) {
				this.errorMessage.push('Please specify email')
			}
			return this.errorMessage
		},

		async handleFormSubmit(event) {
			event.preventDefault();
			this.preloaderStatus = true;
			if (!this.validate().length) {
				this.activeStatus = true
				const data = {
					email: this.email
				}
				if (this.password) {
					data.password = this.password
				}
				const response = await SolFileAPIInstance.setAdminInfo(data)
				if (200 === response.status) {
					await this.$router.push({
						path: '/'
					})
				}
			}
			this.preloaderStatus = false;
		}
	}
}
</script>

<style scoped lang="scss">

input {
  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
}

</style>